// 20.1.2.3 Number.isInteger(number)
var $export = require('./_export');

$export($export.S, 'Number', { isInteger: require('./_is-integer') });



/*****************
 ** WEBPACK FOOTER
 ** /Users/luca/dev/juta/ironex.it/~/core-js/modules/es6.number.is-integer.js
 ** module id = 208
 ** module chunks = 0
 **/